import { sidebarConfig } from '@backstage/core-components';
import { useTheme } from '@material-ui/core';

export const FullSideBarLogoB = ({ height = 2.3 }: { height?: number }) => {
  const theme = useTheme();
  const logoSource = theme.palette.type === 'dark' ? '/light.png' : '/dark.png';

  return (
    <img
      src={logoSource}
      alt="Logo"
      style={{
        display: 'block',
        margin: '0 auto',
        height: height * sidebarConfig.logoHeight,
      }}
    />
  );
};
